import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function AICollegeList(props) {
  const { articles, showType } = props;

  return (
    <Root {...props}>
      <List>
        {
          articles.map((article) => (
            <a href={article.url} target="_blank" rel="noreferrer" key={article.title}>
              <Article>
                <ArticleTitle>
                  <ArticleType show={showType}>{article.type}</ArticleType>
                  <ArticleContent>{article.title}</ArticleContent>
                </ArticleTitle>
                {/* <ArticleDate>{article.date}</ArticleDate> */}
              </Article>
            </a>
          ))
        }
      </List>
    </Root>
  )
}

AICollegeList.propTypes = {
  articles: PropTypes.array,
  showType: PropTypes.bool
}

AICollegeList.defaultProps = {
  articles: []
}

const Root = styled.div`
  width: 100%;
`;

const List = styled.ul`
  margin: 0;
  padding: 0;

  & > a:nth-of-type(2n+1) > li {
    background: rgba(51, 152, 220, 0.15);
  }

  & > a:nth-of-type(2n) > li {
    background: white;
  }
`;

const Article = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  ${vw('padding-top', 3, 6, 12)}
  ${vw('padding-bottom', 3, 6, 12)}
  ${vw('padding-left', 10, 20)}
  ${vw('padding-right', 10, 20)}
  ${vw('margin-bottom', 10, 20, 24)}

  &:hover {
    p, span {
      color: #3398DC;
    }
  }
`;

const ArticleTitle = styled.div`
  width: 78%;
  display: flex;
`;

const ArticleType = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  display: ${props => props.show ? 'flex' : 'none'};
  align-items: center;
  color: #FFFFFF;
  background: #26304D;
  
  ${vw('font-size', 10, 14)}
  ${vw('line-height', 18, 25)}
  ${vw('border-radius', 30)}
  ${vw('margin-right', 10)}
`;

const ArticleContent = styled.p`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  color: #252525;
  transition: all 0.25s;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${vw('font-size', 10, 14)}
    ${vw('line-height', 18, 25)}
`;

// const ArticleDate = styled.span`
//   width: 22%;
//   font-family: 'Noto Sans TC';
//   font-style: normal;
//   font-weight: 400;
//   text-align: right;
//   color: #757575;
//   transition: all 0.25s;

//   font-size: 12px;
//   line-height: 17px;
// `;

export default AICollegeList
